import HapiJoi, { type StringSchema } from '@hapi/joi';

import { extendJoi } from '@sine/joi-extensions';
import abnExtension from '@sine/joi-extensions/extensions/ABN.ext';
import momentExtension from '@sine/joi-extensions/extensions/moment.ext';
import passwordStrengthExtension from '@sine/joi-extensions/extensions/passwordStrength.ext';
import phoneNumberExtension from '@sine/joi-extensions/extensions/phoneNumber.ext';

import topLevelDomains from './tlds';

export const MIN_CHARACTERS = 2;
export const IDENTIFIER_OTHER_MAX_LENGTH = 128;
export const MAX_CHARACTERS = 255;
export const URL_MAX_CHARACTERS = 2000;

const Joi = extendJoi(HapiJoi, [abnExtension, momentExtension, passwordStrengthExtension, phoneNumberExtension]);

export const validEmail = () =>
  Joi.string()
    .trim()
    .email({ minDomainSegments: 2, tlds: { allow: topLevelDomains } });

export const uuidv4 = () => Joi.string().uuid({ version: 'uuidv4' });

export const characterLimitedString = (limit: number = MAX_CHARACTERS): StringSchema => {
  return Joi.string().max(limit).trim();
};

export default Joi;
